import { useState } from "react";

import { post } from "../../common/net/requester";
import {
    Quest,
    QUEST_DIFFICULTY,
    NOTI_FREQ,
    Objective,
} from "../../interfaces";

import "../../styles/questedit.css";
import "../../styles/objective.css";
import QuestEdit from "./QuestEdit";

const NewQuest = ({ addQuest }: { addQuest: (x: Quest) => void }) => {
    const [quest, setQuest] = useState<Quest>({
        id: "",
        dateCreated: "",
        dateUpdated: "",
        userId: "",
        title: "",
        desc: "",
        dateStarted: "",
        dateFinished: "",
        intendedEndDate: "",
        difficulty: QUEST_DIFFICULTY.GRAY,
        objectives: [],
        battles: [],
        notification: {
            reminder: {
                active: true,
                timestamp: "08:00",
                freq: NOTI_FREQ.DAILY,
            },
            prompt: {
                active: false,
                timestamp: "15:04",
                freq: NOTI_FREQ.DAILY,
            },
            daysLeft: {
                active: false,
                timestamp: "15:04",
                freq: NOTI_FREQ.DAILY,
            },
        },
    });

    const submitQuest = () => {
        // TODO: client-side validation
        post<Quest>("/quest", {
            title: quest.title,
            desc: quest.desc,
            dateStarted: quest.dateStarted,
            intendedEndDate: quest.intendedEndDate,
            difficulty: quest.difficulty,
            objectives: quest.objectives,
            notification: quest.notification,
        })
            .then((res) => {
                if (res.ok) {
                    addQuest(res.body);
                    return;
                }

                console.log(res.status, res.message);
            })
            .catch((err) => console.log("failed to create quest:", err));
    };

    const addObjective = (objective: Objective) => {
        setQuest((p) => ({ ...p, objectives: [...p.objectives, objective] }));
    };

    return (
        <QuestEdit
            quest={quest}
            setQuest={setQuest}
            submitObjective={addObjective}
            submit={submitQuest}
        />
    );
};

export default NewQuest;
